// @flow

import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

import './LeftIndicator.scss';

export default class LeftIndicator extends Component{
  constructor(props) {
    super(props);

    this.state = {
      fastGround: false,
      puttyMass: true,
      fastShell: false
    };
  }

  render() {

    return (
      <div className="left-indicator__container">
        <h3 className={"indicator-title" + (this.props.fastGround ? " active" : "")}>Szybki grunt</h3>
        <h3 className={"indicator-title" + (this.props.puttyMass ? " active" : "")}>Masa szpachlowa</h3>
        <h3 className={"indicator-title" + (this.props.fastShell ? " active" : "")}>szybka powłoka</h3>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/LeftIndicator/LeftIndicator.js